// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_TreatmentCard_Content_TreatmentCard_Events_Content($user_id: uuid!, $location_id: uuid!) {
  user_location_preferences_by_pk(
    user_id: $user_id
    location_id: $location_id
  ) {
    user_id
    location_id
    timeline_filter_presets
  }
  apps_displays(type: ADMIN_PATIENT_TREATMENT_TIMELINE) {
    id
    displays
  }
}

`